/** Типизированное состояние D&D для сессий.
 * Используем module-level объект вместо window — полностью типизировано,
 * не загрязняет глобальное пространство имён, нет рефов и стейта (нет ре-рендеров) */
interface ScheduleDragState {
  sessionId: string | null;
  isRecorded: boolean;
  committedSessionId: string | null;
}

export const scheduleDragState: ScheduleDragState = {
  sessionId: null,
  isRecorded: false,
  committedSessionId: null,
};

export function setDraggingSession(id: string, isRecorded: boolean): void {
  scheduleDragState.sessionId = id;
  scheduleDragState.isRecorded = isRecorded;
}

export function clearDraggingSession(): void {
  scheduleDragState.sessionId = null;
  scheduleDragState.isRecorded = false;
}

export function markSessionDropCommitted(id: string): void {
  scheduleDragState.committedSessionId = id;
}

export function consumeSessionDropCommitted(id: string): boolean {
  if (scheduleDragState.committedSessionId !== id) return false;
  scheduleDragState.committedSessionId = null;
  return true;
}
